import "./style.css";
import Orchestrator from "./ThreeJS/Orchestrator.js";
import gsap from "gsap";
import { LANGS, startDark, startLang, save } from "./prefs.js";

const orchestrator = new Orchestrator(document.querySelector("canvas.webgl"));


// ---------------- Theme: light or dark, the 3D grid follows ----------------
const themeBtn = document.querySelector( ".theme" );
const setDark = ( dark, animate ) => {
    document.body.classList.toggle( "darkmode", dark );
    themeBtn.setAttribute( "aria-pressed", String( dark ) );
    orchestrator.stage.setTheme( dark, animate ? 0.8 : 0 );
};
setDark( startDark(), false );
themeBtn.addEventListener( "click", () => {
    const dark = !document.body.classList.contains( "darkmode" );
    setDark( dark, true );
    save( "theme", dark ? "dark" : "light" );
} );

// ---------------- Languages: French is the page itself, the others replace its texts ----------------
const S = ( t ) => '<span class="secondary str">' + t + "</span>";
const I18N = {
    fr: {
        title: "REMEDY",
        hero: "Chez " + S( "REMEDY" ) + " nous concevons des " + S( "solutions digitales" ) + " modernes pour propulser votre " + S( "entreprise" ) + ". Nous transformons vos idées et vos besoins métier en solutions digitales performantes, intuitives et évolutives. " + S( "Applications, sites Web, E-commerce ... <br> Nous donnons vie à vos idées." ),
        location: "Basé à Tétouan, Maroc", solutions: "Nos solutions",
        doc: "Cabinet médical", erp: "Gestion commerciale", pos: "Point de vente",
        close: "Fermer", lang: "Langue", theme: "Thème clair ou sombre",
    },
    en: {
        title: "REMEDY",
        hero: "At " + S( "REMEDY" ) + " we design modern " + S( "digital solutions" ) + " to drive your " + S( "business" ) + " forward. We turn your ideas and business needs into digital solutions that are efficient, intuitive and scalable. " + S( "Applications, websites, e-commerce ... <br> We bring your ideas to life." ),
        location: "Based in Tetouan, Morocco", solutions: "Our solutions",
        doc: "Medical practice", erp: "Business management", pos: "Point of sale",
        close: "Close", lang: "Language", theme: "Light or dark theme",
    },
    es: {
        title: "REMEDY",
        hero: "En " + S( "REMEDY" ) + " diseñamos " + S( "soluciones digitales" ) + " modernas para impulsar su " + S( "empresa" ) + ". Transformamos sus ideas y las necesidades de su negocio en soluciones digitales eficaces, intuitivas y escalables. " + S( "Aplicaciones, sitios web, e-commerce ... <br> Damos vida a sus ideas." ),
        location: "Con sede en Tetuán, Marruecos", solutions: "Nuestras soluciones",
        doc: "Consulta médica", erp: "Gestión comercial", pos: "Punto de venta",
        close: "Cerrar", lang: "Idioma", theme: "Tema claro u oscuro",
    },
    nl: {
        title: "REMEDY",
        hero: "Bij " + S( "REMEDY" ) + " ontwerpen we moderne " + S( "digitale oplossingen" ) + " die uw " + S( "bedrijf" ) + " vooruit helpen. We zetten uw ideeën en bedrijfsbehoeften om in digitale oplossingen die krachtig, intuïtief en schaalbaar zijn. " + S( "Applicaties, websites, e-commerce ... <br> Wij brengen uw ideeën tot leven." ),
        location: "Gevestigd in Tetouan, Marokko", solutions: "Onze oplossingen",
        doc: "Medische praktijk", erp: "Handelsbeheer", pos: "Kassasysteem",
        close: "Sluiten", lang: "Taal", theme: "Licht of donker thema",
    },
    // No diacritics: the light Bein draws them badly
    ar: {
        title: "REMEDY",
        hero: "في " + S( "REMEDY" ) + " نصمم " + S( "حلولا رقمية" ) + " حديثة لتطوير " + S( "مقاولتك" ) + ". نحول أفكارك واحتياجات عملك إلى حلول رقمية فعالة وسهلة الاستعمال وقابلة للتطور. " + S( "تطبيقات، مواقع ويب، تجارة إلكترونية ... <br> نمنح الحياة لأفكارك." ),
        location: "مقرنا في تطوان، المغرب", solutions: "حلولنا",
        doc: "العيادة الطبية", erp: "التسيير التجاري", pos: "صندوق البيع",
        close: "إغلاق", lang: "اللغة", theme: "الوضع الفاتح أو الداكن",
    },
};

const langBox = document.querySelector( ".lang" );
const langBtn = langBox.querySelector( ".lang__btn" );
const setLangMenu = ( open ) => {
    langBox.classList.toggle( "is-open", open );
    langBtn.setAttribute( "aria-expanded", String( open ) );
};
const setLang = ( lang ) => {
    const t = I18N[ lang ];
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.title = t.title;
    document.querySelectorAll( "[data-i18n]" ).forEach( ( el ) => { el.innerHTML = t[ el.dataset.i18n ]; } );
    document.querySelectorAll( "[data-i18n-aria]" ).forEach( ( el ) => { el.setAttribute( "aria-label", t[ el.dataset.i18nAria ] ); } );
    langBtn.querySelector( ".lang__code" ).textContent = lang.toUpperCase();
    langBox.querySelectorAll( "[data-lang]" ).forEach( ( b ) => b.setAttribute( "aria-checked", String( b.dataset.lang === lang ) ) );
};
setLang( startLang() );
langBtn.addEventListener( "click", ( e ) => { e.stopPropagation(); setLangMenu( !langBox.classList.contains( "is-open" ) ); } );
langBox.querySelectorAll( "[data-lang]" ).forEach( ( b ) => b.addEventListener( "click", () => {
    if( LANGS.includes( b.dataset.lang ) ) { setLang( b.dataset.lang ); save( "lang", b.dataset.lang ); }
    setLangMenu( false );
    langBtn.focus();
} ) );
document.addEventListener( "click", ( e ) => { if( !langBox.contains( e.target ) ) setLangMenu( false ); } );

// Staggered fade-in animation for text elements
const animatedElements = [
    ".nav-logo a",
    ".nav-links a",
    ".tools",
    ".nav-socials a",
    ".nav-time p",
    ".hero-section h1",
    ".bar-location p",
    ".bar-projects a",
    ".bar-availability a",
];

gsap.fromTo(
    animatedElements,
    {
        opacity: 0,
        y: 20,
    },
    {
        duration: 1,
        opacity: 1,
        y: 0,
        stagger: 0.1,
        ease: "power3.out",
        delay: 0.5,
    },
);

// "Nos solutions": opens and closes the panel of the apps
const apps = document.querySelector( "#solutions" );
const appsToggle = document.querySelector( ".apps-toggle" );
const setApps = ( open ) => {
    apps.classList.toggle( "is-open", open );
    apps.setAttribute( "aria-hidden", String( !open ) );
    appsToggle.setAttribute( "aria-expanded", String( open ) );
    if( open ) apps.querySelector( ".apps__panel" ).focus( { preventScroll: true } );
    else appsToggle.focus( { preventScroll: true } );
};
appsToggle.addEventListener( "click", ( e ) => { e.preventDefault(); setApps( !apps.classList.contains( "is-open" ) ); } );
apps.querySelector( ".apps__close" ).addEventListener( "click", () => setApps( false ) );
apps.querySelector( ".apps__backdrop" ).addEventListener( "click", () => setApps( false ) );
document.addEventListener( "keydown", ( e ) => {
    if( e.key !== "Escape" ) return;
    if( langBox.classList.contains( "is-open" ) ) { setLangMenu( false ); langBtn.focus(); }
    else if( apps.classList.contains( "is-open" ) ) setApps( false );
} );
